var _symbol, _symbol2, _symbol3, _symbol4, _symbol5, _symbol6, _symbol7, _symbol8, _symbol9, _symbol10, _symbol11, _defs, _path, _path2, _path3, _path4, _mask, _use, _g, _symbol12, _symbol13, _symbol14, _symbol15;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSprite(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 0,
    height: 0,
    style: {
      position: "absolute"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _symbol || (_symbol = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 12 7",
    id: "icons-arrow-down",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.707.293A1 1 0 0 0 .293 1.707l5 5a1 1 0 0 0 1.414 0l5-5A1 1 0 1 0 10.293.293L6 4.586 1.707.293z"
  }))), _symbol2 || (_symbol2 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 70 70",
    id: "icons-benefit-completed",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ba",
    x1: "50%",
    x2: "50%",
    y1: ".592%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EBEFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B2C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "be",
    x1: "22.44%",
    x2: "85.566%",
    y1: "9.042%",
    y2: "86.591%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5985FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0034A0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "bc",
    d: "M9.815 31.185c-6.42-6.45-6.42-16.92 0-23.37 6.45-6.42 16.92-6.42 23.37 0 6.42 6.45 6.42 16.92 0 23.37-6.45 6.42-16.92 6.42-23.37 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "bd",
    d: "M7.207 28.793c-5.61-6.05-5.61-15.536 0-21.587 6.05-5.608 15.536-5.608 21.586 0 5.61 6.051 5.61 15.536 0 21.587-6.05 5.61-15.535 5.61-21.586 0z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "bb",
    width: "254.5%",
    height: "254.5%",
    x: "-77.3%",
    y: "-59.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.606063857 0 0 0 0 0.696259809 0 0 0 0 0.917649872 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "url(#ba)",
    opacity: 0.501,
    rx: 35
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17 17)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#bb)",
    xlinkHref: "#bc"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#305EFF",
    d: "M5.253 30.747c-7.004-7.037-7.004-18.458 0-25.494 7.036-7.004 18.458-7.004 25.494 0 7.004 7.036 7.004 18.457 0 25.494-7.036 7.004-18.458 7.004-25.494 0z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "bf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#bd"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#be)",
    xlinkHref: "#bd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.365 26.635c-4.487-4.841-4.487-12.43 0-17.27 4.841-4.487 12.43-4.487 17.27 0 4.487 4.84 4.487 12.429 0 17.27-4.84 4.487-12.429 4.487-17.27 0z",
    mask: "url(#bf)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 12,
    x: 14,
    y: 12,
    fill: "#305EFF",
    fillRule: "nonzero",
    mask: "url(#bf)",
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 12,
    x: 19,
    y: 12,
    fill: "#305EFF",
    fillRule: "nonzero",
    mask: "url(#bf)",
    rx: 1.5
  }))))), _symbol3 || (_symbol3 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 70 70",
    id: "icons-benefit-considered",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "ca",
    x1: "50%",
    x2: "50%",
    y1: ".592%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EBEFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B2C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ce",
    x1: "22.44%",
    x2: "85.566%",
    y1: "9.042%",
    y2: "86.591%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5985FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0034A0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "cc",
    d: "M9.815 31.185c-6.42-6.45-6.42-16.92 0-23.37 6.45-6.42 16.92-6.42 23.37 0 6.42 6.45 6.42 16.92 0 23.37-6.45 6.42-16.92 6.42-23.37 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cd",
    d: "M7.207 28.793c-5.61-6.05-5.61-15.536 0-21.587 6.05-5.608 15.536-5.608 21.586 0 5.61 6.051 5.61 15.536 0 21.587-6.05 5.61-15.535 5.61-21.586 0z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "cb",
    width: "254.5%",
    height: "254.5%",
    x: "-77.3%",
    y: "-59.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.606063857 0 0 0 0 0.696259809 0 0 0 0 0.917649872 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "url(#ca)",
    opacity: 0.501,
    rx: 35
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(17 17)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#cb)",
    xlinkHref: "#cc"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#305EFF",
    d: "M5.253 30.747c-7.004-7.037-7.004-18.458 0-25.494 7.036-7.004 18.458-7.004 25.494 0 7.004 7.036 7.004 18.457 0 25.494-7.036 7.004-18.458 7.004-25.494 0z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "cf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cd"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#ce)",
    xlinkHref: "#cd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M9.365 26.635c-4.487-4.841-4.487-12.43 0-17.27 4.841-4.487 12.43-4.487 17.27 0 4.487 4.84 4.487 12.429 0 17.27-4.84 4.487-12.429 4.487-17.27 0z",
    mask: "url(#cf)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#305EFF",
    fillRule: "nonzero",
    mask: "url(#cf)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(-45 25.759 -3.473)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 9,
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3,
    height: 13,
    x: 5,
    y: 1,
    rx: 1.5,
    transform: "rotate(-90 6.5 7.5)"
  }))))))), _symbol4 || (_symbol4 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 70 70",
    id: "icons-benefit-time",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "da",
    x1: "50%",
    x2: "50%",
    y1: ".592%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EBEFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B2C8FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "de",
    x1: "81.899%",
    x2: "17.915%",
    y1: "87.747%",
    y2: "13.411%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#5985FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0034A0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dg",
    x1: "0%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#92BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5985FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "dh",
    x1: "-26.067%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#92BBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#5985FF"
  })), /*#__PURE__*/React.createElement("path", {
    id: "dc",
    d: "M4.815 28.185c-6.42-6.45-6.42-16.92 0-23.37 6.45-6.42 16.92-6.42 23.37 0 6.42 6.45 6.42 16.92 0 23.37-6.45 6.42-16.92 6.42-23.37 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dd",
    d: "M6.786 26.214c-5.048-5.446-5.048-13.983 0-19.428 5.446-5.048 13.983-5.048 19.428 0 5.048 5.445 5.048 13.982 0 19.428-5.445 5.048-13.982 5.048-19.428 0z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "db",
    width: "254.5%",
    height: "254.5%",
    x: "-77.3%",
    y: "-59.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 6,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 7.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.606063857 0 0 0 0 0.696259809 0 0 0 0 0.917649872 0 0 0 1 0"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    fill: "url(#da)",
    opacity: 0.501,
    rx: 35
  }), /*#__PURE__*/React.createElement("rect", {
    width: 5,
    height: 7,
    x: 36,
    y: 17,
    fill: "#1547B7",
    fillRule: "nonzero",
    rx: 1.5
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(22 20)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#db)",
    xlinkHref: "#dc"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#305EFF",
    d: "M4.815 28.185c-6.42-6.45-6.42-16.92 0-23.37 6.45-6.42 16.92-6.42 23.37 0 6.42 6.45 6.42 16.92 0 23.37-6.45 6.42-16.92 6.42-23.37 0z"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "df",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dd"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "url(#de)",
    xlinkHref: "#dd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M8.917 24.083c-3.941-4.251-3.941-10.915 0-15.166 4.251-3.94 10.915-3.94 15.166 0 3.94 4.25 3.94 10.915 0 15.166-4.25 3.941-10.915 3.941-15.166 0z",
    mask: "url(#df)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#305EFF",
    d: "M19.499 21a1.49 1.49 0 0 1-.831-.252L15 18.303V11.5a1.5 1.5 0 1 1 3 0v5.197l2.332 1.555A1.5 1.5 0 0 1 19.499 21",
    mask: "url(#df)"
  })), /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 3,
    x: 10,
    y: 29,
    fill: "url(#dg)",
    fillRule: "nonzero",
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 3,
    x: 11,
    y: 36,
    fill: "url(#dg)",
    fillRule: "nonzero",
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 7,
    height: 3,
    x: 13,
    y: 43,
    fill: "url(#dh)",
    fillRule: "nonzero",
    rx: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 3,
    x: 33,
    y: 16,
    fill: "#305EFF",
    fillRule: "nonzero",
    rx: 1.5
  })))), _symbol5 || (_symbol5 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 10 10",
    id: "icons-cancel",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 3.653.919-.427A.952.952 0 1 0-.428.918L3.652 5l-4.08 4.08a.953.953 0 0 0 1.347 1.347L5 6.348l4.08 4.08a.953.953 0 0 0 1.348-1.347l-4.08-4.08 4.08-4.082A.953.953 0 0 0 9.08-.428L5 3.652z"
  }))), _symbol6 || (_symbol6 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 15 13",
    id: "icons-circle-arrow",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#69758B",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    opacity: 0.498
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.519 1.6v3.6h3.6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.025 8.2a5.4 5.4 0 1 0 1.278-5.616L1.519 5.2"
  })))), _symbol7 || (_symbol7 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 15 15",
    id: "icons-completed",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00BD7B",
    fillRule: "evenodd",
    d: "M7.5 15a7.5 7.5 0 1 1 0-15 7.5 7.5 0 0 1 0 15zM5.043 6.742a1.071 1.071 0 0 0-1.515 1.516L5.671 10.4a1.071 1.071 0 0 0 1.515 0l4.286-4.285A1.071 1.071 0 1 0 9.957 4.6L6.429 8.128 5.043 6.742z"
  }))), _symbol8 || (_symbol8 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    id: "icons-error",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF0F39",
    fillRule: "evenodd",
    d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm1-8V5a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0zm-2 3.012c0 .537.451.988 1 .988.561 0 1-.451 1-.988a1 1 0 1 0-2 0z"
  }))), _symbol9 || (_symbol9 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 20 18",
    id: "icons-go-back-to",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 16.975H3c-1.105 0-2-.894-2-1.997V2.997C1 1.894 1.895 1 3 1h5m4 3.994L8 8.988l4 3.994M8 9h11",
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }))), _symbol10 || (_symbol10 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    id: "icons-info",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M8 16A8 8 0 1 1 8 0a8 8 0 0 1 0 16zm1-4V7H7v5h2zM7 5.012a1.001 1.001 0 0 0 2 0 1 1 0 1 0-2 0z"
  }))), _symbol11 || (_symbol11 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 30 30",
    id: "icons-loader",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3c7bff",
    d: "M0 15a2 2 0 1 1 4 0c0 6.075 4.925 11 11 11s11-4.925 11-11S21.075 4 15 4a2 2 0 1 1 0-4c8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15-8.284 0-15-6.716-15-15z"
  }))), /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 123 24",
    id: "icons-logo",
    xmlns: "http://www.w3.org/2000/svg"
  }, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "la",
    x1: "50%",
    x2: "50%",
    y1: "95.489%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#082FAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0E71E8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lb",
    x1: "50%",
    x2: "50%",
    y1: "95.489%",
    y2: "0%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#082FAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "55.485%",
    stopColor: "#0E71E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1095F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "lc",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "94.657%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0F9FFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#154ADD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "ld",
    x1: "50%",
    x2: "50%",
    y1: "4.423%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#0BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0073E2"
  })), /*#__PURE__*/React.createElement("path", {
    id: "le",
    d: "M18.69 10.716c-.793 2.067-2.665 3.667-4.802 4.106-2.137.439-4.47-.298-5.99-1.89-1.636-1.717-2.237-4.158-3.137-6.368C3.86 4.355 2.32 2.086 0 1.712 1.274.548 2.888-.122 4.594.018a6.376 6.376 0 0 1 4.417 2.377c1.194 1.506 1.663 3.473 2.665 5.119.735 1.208 1.837 2.372 3.081 3.017 1.016.526 2.75.937 3.934.185"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#la)",
    d: "m14.079 20.764 7.76-15.85c0-.004-4.438-.997-6.181 2.435a3672.246 3672.246 0 0 1-6.32 12.255c1.024 1.042 1.877 1.647 2.56 1.814.683.167 1.41-.051 2.181-.654z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lb)",
    d: "m18.857 18.234 6.958-13.612s3.158-7.259 11.323-3.583c0 0-1.762.687-3.88 3.95-3.428 5.284-7.398 14.656-7.398 14.656-1.508 1.408-2.664 2.036-3.467 1.884-.854-.161-2.033-1.26-3.536-3.295z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#lc)",
    d: "M14.165 20.581c-.602 1.58-2.02 2.79-3.654 3.124-1.605.33-3.374-.228-4.511-1.424-1.254-1.306-1.71-3.151-2.391-4.824-.683-1.668-1.85-3.384-3.609-3.675.966-.872 2.189-1.378 3.474-1.286 1.3.12 2.54.785 3.338 1.791.922 1.158 1.278 2.646 2.03 3.905.564.898 1.4 1.778 2.346 2.251.765.413 2.08.724 2.977.138"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#ld)",
    d: "M25.864 19.582c-.795 2.068-2.666 3.668-4.803 4.106-2.137.44-4.471-.298-5.99-1.89-1.636-1.716-2.238-4.158-3.138-6.367-.9-2.21-2.44-4.479-4.76-4.852 1.274-1.164 2.888-1.834 4.594-1.694a6.376 6.376 0 0 1 4.417 2.376c1.194 1.506 1.663 3.474 2.665 5.12.735 1.207 1.837 2.371 3.08 3.016 1.016.526 2.75.938 3.935.185"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.402,
    transform: "translate(7.173 8.866)"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "lf",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#le"
  }))), _use || (_use = /*#__PURE__*/React.createElement("use", {
    fill: "url(#ld)",
    xlinkHref: "#le"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#la)",
    d: "m6.906 11.897 7.76-15.85c0-.003-4.438-.996-6.18 2.436a3672.252 3672.252 0 0 1-6.32 12.255c1.023 1.042 1.877 1.646 2.56 1.813.682.167 1.409-.05 2.18-.654z",
    mask: "url(#lf)",
    style: {
      mixBlendMode: "overlay"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m54.756 8.94-2.046 8.218-2.187-7.983h-2.445l-2.21 7.983-2.023-8.219H41l3.433 11.775h2.445l2.422-7.677 2.422 7.677h2.446L57.6 8.94zM59.2 20.714h2.915V8.94H59.2v11.775zm0-13.564h2.915V4.23H59.2v2.92zm6.395 12.94c-.502-.573-.752-1.315-.752-2.225V3.052h2.915v13.612c0 .628.036 1.071.106 1.33.07.26.196.416.376.471.18.055.646.083 1.085.083v2.402h-1.472c-1.004 0-1.756-.287-2.258-.86m6.184 0c-.502-.573-.752-1.315-.752-2.225V3.052h2.915v13.612c0 .628.036 1.071.106 1.33.07.26.196.416.376.471.18.055.646.083 1.085.083v2.402h-1.473c-1.003 0-1.756-.287-2.257-.86m6.713.648c-.62-.142-1.012-.244-1.67-.542v-2.614a9.995 9.995 0 0 0 1.858.883 5.427 5.427 0 0 0 1.775.295c1.191 0 1.787-.393 1.787-1.178 0-.424-.157-.75-.47-.977-.314-.228-.878-.498-1.693-.813-1.16-.424-2.014-.906-2.563-1.448-.549-.542-.823-1.275-.823-2.202 0-1.02.392-1.848 1.176-2.484.783-.636 1.842-.954 3.174-.954 1.332 0 2.547.306 3.645.918v2.666c-.596-.408-1.415-.891-1.94-1.111a4.255 4.255 0 0 0-1.658-.33c-.502 0-.89.102-1.164.306-.274.204-.411.495-.411.871 0 .299.082.542.247.73.164.189.395.358.693.507.298.15.792.357 1.482.624 1.144.44 1.967.922 2.469 1.448.501.526.752 1.229.752 2.108 0 1.115-.4 1.978-1.2 2.59-.799.613-1.935.919-3.409.919a9.26 9.26 0 0 1-2.057-.212m16.51-1.01-.42.28a5.24 5.24 0 0 1-1.246.671c-.47.18-.925.27-1.364.27-1.74 0-3.006-.501-3.798-1.506-.791-1.005-1.187-2.394-1.187-4.169V8.94h2.916v6.335c0 1.1.184 1.912.552 2.438.368.526.96.789 1.776.789.909 0 1.645-.33 2.21-.99V8.94h2.899v.02m10.808 8.575c.478-.675.717-1.57.717-2.685 0-1.114-.239-2.009-.717-2.684-.478-.675-1.148-1.013-2.01-1.013-.988 0-1.725.33-2.21.99-.487.659-.73 1.562-.73 2.707 0 1.147.243 2.05.73 2.709.485.659 1.222.989 2.21.989.862 0 1.532-.338 2.01-1.013m1.282-7.96c.8.55 1.403 1.288 1.81 2.214.408.926.612 1.947.612 3.061 0 1.115-.204 2.136-.612 3.062a5.13 5.13 0 0 1-1.81 2.214c-.8.55-1.756.824-2.869.824-1.239 0-2.218-.338-3.221-1.013v.777h-2.916V3.052h2.916v6.759a5.287 5.287 0 0 1 3.221-1.06c1.113 0 2.07.275 2.869.824m7.171 5.723h-3.15v-2.214h3.15V9.93H119v3.155h3.15v2.214H119v3.155h-2.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.18 19.96c-.502-.573-.753-1.315-.753-2.225V8.959h2.916v7.575c0 .628.035 1.071.106 1.33.07.26.196.416.376.471.18.055.646.083 1.085.083v2.402h-1.473c-1.003 0-1.756-.287-2.257-.86"
  }))))), _symbol12 || (_symbol12 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    id: "icons-show",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#69758B",
    fillOpacity: 0.5,
    fillRule: "evenodd",
    d: "M8 3C4.364 3 1.258 5.28 0 8.5 1.258 11.72 4.364 14 8 14s6.742-2.28 8-5.5C14.742 5.28 11.636 3 8 3zm0 9.166c-2.007 0-3.636-1.642-3.636-3.666S5.993 4.833 8 4.833s3.636 1.643 3.636 3.667S10.007 12.166 8 12.166zM8 6.3a2.188 2.188 0 0 0-2.182 2.2c0 1.217.975 2.2 2.182 2.2a2.188 2.188 0 0 0 2.182-2.2c0-1.217-.975-2.2-2.182-2.2z"
  }))), _symbol13 || (_symbol13 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    id: "icons-success",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00BD7B",
    d: "M13.59 2.403a1.439 1.439 0 0 1 1.997 0 1.35 1.35 0 0 1 0 1.944l-8.471 8.25a1.439 1.439 0 0 1-1.997 0L.413 8.014a1.35 1.35 0 0 1 0-1.945 1.439 1.439 0 0 1 1.997 0L6.118 9.68l7.472-7.277z"
  }))), _symbol14 || (_symbol14 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 15",
    id: "icons-user",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 8a4 4 0 1 1 0-8 4 4 0 0 1 0 8zm-8 7a7.992 7.992 0 0 1 3.52-6.63A6.38 6.38 0 0 0 8 10.2a6.38 6.38 0 0 0 4.48-1.83A7.992 7.992 0 0 1 16 15H0z"
  }))), _symbol15 || (_symbol15 = /*#__PURE__*/React.createElement("symbol", {
    viewBox: "0 0 16 16",
    id: "icons-warning",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#FF8500",
    fillRule: "evenodd",
    d: "m8.857 1.43 7.234 12.056A1 1 0 0 1 15.234 15H.766a1 1 0 0 1-.857-1.514L7.143 1.429a1 1 0 0 1 1.714 0zM9 9V6a1 1 0 1 0-2 0v3a1 1 0 1 0 2 0zm-2 3.012c0 .537.451.988 1 .988.561 0 1-.451 1-.988a1 1 0 1 0-2 0z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSprite);
export default __webpack_public_path__ + "static/media/sprite.ca679f37f054f848a49668a3b0936595.svg";
export { ForwardRef as ReactComponent };